export enum GoalInformation {
    Main,
    TextBasedGoal,
    NumericGoals,
    GroupGoals
}